import script from "./UiCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiCheckbox.vue?vue&type=script&lang=ts&setup=true"

const cssModules = {}
import style0 from "./UiCheckbox.vue?vue&type=style&index=0&id=769084da&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__